<template>
    <div>
        <h1>Dashboard</h1>
        <textarea name="" id="" cols="30" rows="10" v-model="poptip_text"></textarea>
        <iv-poptip trigger="hover" placement="left" width="375" style="margin-left: 500px;">
          <div slot="content" style="
            white-space: normal;" v-html="poptip_text.replace(/\n/g,'<br>')">
          </div>
          <p style="overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;">{{ poptip_text }}</p>
        </iv-poptip>
    </div>
</template>
<style lang="scss" scoped>
.sitemap{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    li{
        width: 25%;
        a,span{
            display: block;
            background-color: #fff;
            margin: 10px;
            padding: 5px 10px;
        }
    }
}
</style>
<script>
export default {
    data() {
        return {
            poptip_text: "【信维通信闪崩盘中大跌17%！“黑天鹅”传闻袭来 此前还发了一则严正声明公告】今日信维通信股价连续下挫，一度跌超17％并跌破50元关口，总市值不足500亿元\n经公司核实，不法分子通过相关平台发布的公司简介、公司LOGO、公司图片、公司证件、公司印章等信息均为盗用或伪造，并未经过公司任何授权，对投资者产生了严重误导，严重侵害了公司的合法权益\nhttp://t.cn/A6baJO13"
        }
    }
}
</script>

